import { StopAppointmentOnCall } from '~/domain/usecases/onCall/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteStopAppointmentOnCall implements StopAppointmentOnCall {
  private readonly url: string;

  private readonly httpClient: HttpClient<StopAppointmentOnCall.Model>;

  constructor(url: string, httClient: HttpClient<StopAppointmentOnCall.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  stopAppointment = async (
    params: StopAppointmentOnCall.Params,
  ): Promise<StopAppointmentOnCall.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url
        .replace('{onCallId}', `${params.onCallId}`)
        .replace('{specialistId}', `${params.specialistId}`)
        .replace('{requesterId}', `${params.requesterId}`),
      method: 'post',
      body: params.outcome ? { outcome: params.outcome } : {},
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
